<template>

    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                        <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                        <div class="flex-1">
                        <h3 class="m-0">Tambah Tugas Teknisi</h3>
                        <p class="mb-0">Lengkapi form di bawah ya gan</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Tugas </label>
                                            <textarea style="height: 100px" class="form-control" row="5" v-model="form.d.text">

                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Teknisi <button class="btn btn-sm btn-info" @click="data.modalTeknisi = true">Tambah</button></label>
                                            <input type="text" class="form-control" placeholder="Tambahkan Teknisi..." v-model="form.d.teknisiNama" disabled>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Pelanggan (opsional) <button class="btn btn-sm btn-info" @click="data.modalPelanggan = true">Tambah</button></label>
                                            <input type="text" class="form-control" placeholder="Tambahkan Pelanggan..." v-model="form.d.pelanggan" disabled>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                <div class="form-group">
                                    <button class="btn btn-primary" @click="form.simpan()">Simpan</button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalTeknisi">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Pilih Teknisi</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalTeknisi = false">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                        <div class="col-md-12" style="height: 400px;overflow:auto">
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                <th>No.</th>
                                <th>Nama</th>
                                <th>Aksi</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in get.d.tList">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ u.nama }}</td>
                                        <td>
                                            <button class="btn btn-sm btn-primary" @click="get.pilihTeknisi(u.id,u.nama)"> Pilih</button> <!-- @click="cariByAdmin(u.nama)" -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="d-flex align-items-center" style="width: 100%;">
                            <div class="text-left" style="flex:1">
                                <small class="d-block">Teknisi : </small>
                                <span>{{form.d.teknisiNama}}</span>
                            </div>
                            <div class="ml-1">
                                <button class="btn btn-secondary" @click="form.d.teknisiNama = null,form.d.teknisiids = null">Reset</button>
                                <button class="btn btn-primary" @click="data.modalTeknisi = false">Oke</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalPelanggan">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cari dan Pilih Pelanggan</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalPelanggan = false">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" placeholder="Cari Pelanggan..." v-model="get.d.pCari" v-on:keyup.enter="get.pelanggan()">
                                    <div class="input-group-append">
                                        <button class="btn btn-sm btn-info" type="button" @click="get.pelanggan()">Cari</button>
                                    </div>
                                </div>  
                            </div>
                            <div class="col-md-12" style="height: 400px;overflow:auto">
                                <div class="table-responsive">
                                <table class="table">
                                    <thead class=" text-info">
                                    <th>No.</th>
                                    <th>Nama</th>
                                    <th>Aksi</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(u, index) in get.d.pList">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ u.nama }}</td>
                                            <td>
                                                <button class="btn btn-sm btn-primary" @click="get.pilihPelanggan(u.uid,u.nama);data.modalPelanggan = false "> Pilih</button> <!-- @click="cariByAdmin(u.nama)" -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import router from '@/router'


import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LIcon } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		moment
	}, 
    setup() {
        const data = reactive({
            modalTeknisi: false,
            modalPelanggan: false
        })
        
        const get = {
            d: reactive({
                tList: [],
                pCari: '',
                pList: []
            }),
            pilihPelanggan(id,nama) {
                form.d.pelanggan = nama;
                form.d.pelangganID = id;
            },
            pelanggan() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    cari: this.d.pCari
                };
            
                var apiUrl = inter.PelangganCariPopup();
                myGlobal.call(datax,apiUrl).then(x => {

                    //myGlobal.loger(x);

                    if (x.status == true) {
                        
                        this.d.pList = x.data;
                    
                    } else {
                        
                    }
                })
            },
            pilihTeknisi(id, nama) {
                var tS = form.d.teknisiids;
                var tM = form.d.teknisiNama;
                if (tS == null) {
                    form.d.teknisiids = id;
                    form.d.teknisiNama = nama;
                } else {
                    if (tS.indexOf(id) !== -1) {
                        myGlobal.loger("Sudah di klik ya sat")
                    } else {
                        form.d.teknisiids = tS+","+id;
                        form.d.teknisiNama = tM+","+nama;
                    }
                }

                //myGlobal.loger(form.d.teknisiids)
            },
            teknisi() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                };
            
                var apiUrl = inter.TeknisiList();
                myGlobal.call(datax,apiUrl).then(x => {
                    console.log(JSON.stringify(x));

                    if (x.status == true) {
                        
                        this.d.tList = x.data;
                    
                    } else {
                        
                    }
                })

            }
        }

        const form = {
            d: reactive({
                text: null,
                teknisiids: null,
                teknisiNama: null,
                pelanggan: null,
                pelangganID: null
            }),
            simpan() {
                var teknisi = this.d.teknisiids;
                var info = this.d.text;
                var pelanggan = this.d.pelangganID;
                if (info == "") {
                    alert("Nomor tidak boleh kosong");
                    return false;
                }
                if (teknisi == "") {
                    alert("Port tidak boleh kosong");
                    return false;
                }

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    info: info,
                    teknisi: teknisi,
                    pelanggan: pelanggan
                };
            
                var apiUrl = inter.TugasTambah();
                myGlobal.call(datax,apiUrl).then(x => {
                    if (x.status == true) {

                        router.push({ 
                            name: 'tugas'
                            /*
                            params: {
                                data: pax
                            } 
                            */
                        });
                    
                    } else {
                        
                    }
                })
            }
        }
        return {
            data,
            get,
            form,
            myGlobal
        }
    },
    
	mounted() {
        document.title = "Tambah Tugas";
		//this.data.params = this.$route.params;

        this.get.teknisi();
	}
}
</script>

<style scoped>

.modal {
	display: inherit;
}
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/tugas/tambah.vue